import { render, staticRenderFns } from "./GaChipFilter.vue?vue&type=template&id=1c44ff8e&scoped=true&"
import script from "./GaChipFilter.vue?vue&type=script&lang=ts&"
export * from "./GaChipFilter.vue?vue&type=script&lang=ts&"
import style0 from "./GaChipFilter.vue?vue&type=style&index=0&id=1c44ff8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c44ff8e",
  null
  
)

export default component.exports